function navigation(carousel) {
  let arrowLeft = document.querySelector('#reviews-carousel .arrow--prev')
  let arrowRight = document.querySelector('#reviews-carousel .arrow--next')

  function arrows() {  
    arrowLeft.addEventListener("click", () => carousel.prev())
    arrowRight.addEventListener("click", () => carousel.next())
  }

  carousel.on("created", () => {
    arrows()
  })
  carousel.on("optionsChanged", () => {
    arrows()
  })
  carousel.on("destroyed", () => {
    arrows()
  })
}

var reviewsCarousel = new KeenSlider("#reviews-carousel", {
  loop: true,
  defaultAnimation: {
    duration: 2000,
  },
  detailsChanged: (s) => {
    s.slides.forEach((element, idx) => {
      element.style.opacity = s.track.details.slides[idx].portion
    })
  },
  renderMode: "custom",
}, [navigation])
